import type { DeepResearchSource } from "./types";

function sourceMarker(source: DeepResearchSource, index: number, legacyPrefix: string): string {
  return source.label ?? `${legacyPrefix}${index + 1}`;
}

/** Formats a completed Deep Research card for the clipboard, matching iOS. */
export function deepResearchCopyText({
  headerLine,
  report,
  sources,
}: {
  headerLine: string;
  report?: string;
  sources: DeepResearchSource[];
}): string {
  const lines = ["Deep Research"];
  if (headerLine) lines.push(headerLine);
  if (report) lines.push("", report);

  const corpusSources = sources.filter((source) => source.origin === "corpus");
  const webSources = sources.filter((source) => source.origin !== "corpus");
  const appendSources = (title: string, items: DeepResearchSource[], prefix: string) => {
    if (items.length === 0) return;
    lines.push("", title);
    items.forEach((source, index) => {
      const destination = source.origin === "corpus"
        ? source.studio_url ?? source.publisher_url
        : source.url;
      const marker = sourceMarker(source, index, prefix);
      lines.push(destination === undefined
        ? `${marker}. ${source.title}`
        : `${marker}. [${source.title}](${destination})`);
    });
  };

  if (sources.length > 0) {
    lines.push("", "Sources");
    appendSources("Library", corpusSources, "C");
    appendSources("Web", webSources, "");
  }
  return lines.join("\n");
}
